import { createSlice } from "@reduxjs/toolkit";
import mergeDeepRight from "ramda/src/mergeDeepRight";

import { BASE_REDUCERS, getBaseReducers } from "../../utils/redux";

const productTypesState = {};
const productTypesReducers = {};

const baseReducers = getBaseReducers([BASE_REDUCERS.NETWORK, BASE_REDUCERS.ENTITY]);

const initialState = mergeDeepRight(baseReducers.state, productTypesState);
const reducers = { ...baseReducers.reducers, ...productTypesReducers };

const slice = createSlice({
  name: "PRODUCT_TYPES",
  initialState,
  reducers,
});

export const { actions: productTypesActions, reducer: exampleReducer } = slice;
